module.exports = __webpack_public_path__ + "static/akc-citizen-8ec1a8a61e8fc6a3cd05eba660608c20.png";